import { getJSON, deleteJSON } from "@js/helpers/communication.js";

export const SET_USER_INPUT = "SET_USER_INPUT";

export const setUserInput = (value) => ({
  type: SET_USER_INPUT,
  value: value,
});

export const SEARCH_STARTED = "SEARCH_STARTED";
export const SEARCH_SUCCESS = "SEARCH_SUCCESS";
export const SEARCH_FAILURE = "SEARCH_FAILURE";
export const SEARCH_ABORTED = "SEARCH_ABORTED";

export const doSearch = () => (dispatch, getState) => {
  dispatch({ type: SEARCH_STARTED });

  const initState = getState();
  const url = Routes.test_suppression_list_path({ id: initState.suppressionListID }, { address: initState.userInput });

  getJSON(url, (data, err) => {
    if ( err ) {
      dispatch({ type: SEARCH_FAILURE, error: err });
      return;
    } else if ( data.error_message ) {
      dispatch({ type: SEARCH_FAILURE, error: data.error_message });
      return;
    }

    dispatch({ type: SEARCH_SUCCESS, data: data });
  });
};

export const DELETE_CONFIRM = "DELETE_CONFIRM";
export const DELETE_STARTED = "DELETE_STARTED";
export const DELETE_SUCCESS = "DELETE_SUCCESS";
export const DELETE_FAILURE = "DELETE_FAILURE";
export const DELETE_ABORTED = "DELETE_ABORTED";

export const doDelete = (id, name) => ({
  type: DELETE_CONFIRM,
  id: id,
  name: name,
});

export const doDeleteConfirmed = () => (dispatch, getState) => {
  dispatch({ type: DELETE_STARTED });

  const initState = getState();
  const url = Routes.suppressed_address_path({ id: initState.confirmDeleteID });
  deleteJSON(url, (data, err) => {
    if ( err ) {
      alert("error deleting (comm): " + err);
      return;
    } else if ( data.error_message ) {
      alert("error deleting: " + data.error_message);
      return;
    }

    dispatch({ type: DELETE_SUCCESS, id: initState.confirmDeleteID });
  });
};

export const doDeleteCancel = () => ({
  type: DELETE_ABORTED,
});
